/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { CustomProductDetailsState, CustomProductState } from "@eisinc/App/Store/Reducers/ProductDetails/state";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: CustomProductDetailsState = {
    byId: {},
};

const reducer = createTypedReducerWithImmer(initialState, {
    "Pages/ProductDetails/SetProductVideos": (
        draft: Draft<CustomProductDetailsState>,
        action: { customProductState: CustomProductState },
    ) => {
        draft.byId[action.customProductState.productId] = action.customProductState;
    },
    "Pages/ProductDetails/SetSelectedVideoIndex": (
        draft: Draft<CustomProductDetailsState>,
        action: { index: number; product: ProductModel },
    ) => {
        if (draft.byId[action.product.id]) {
            draft.byId[action.product.id].selectedVideoIndex = action.index;
        }
    },
});

(reducers as any).customProductDetails = reducer;
